var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.615 20C7.155 20 6.771 19.846 6.463 19.538C6.15433 19.2293 6 18.845 6 18.385V6H5V5H9V4.23H15V5H19V6H18V18.385C18 18.845 17.846 19.229 17.538 19.537C17.2293 19.8457 16.845 20 16.385 20H7.615ZM9.808 17H10.808V8H9.808V17ZM13.192 17H14.192V8H13.192V17Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b3e043a3f51a3fe2bc094e846bc4a92f.svg";
export { ForwardRef as ReactComponent };